import React from 'react';

/**
 * Displays a message indicating the content is not available in the user's location.
 */
const NotAvailableScreen = () => (
  <>
    <h2 data-testid="not-available">We’re sorry, this content is not available in your location.</h2>
  </>
);

export { NotAvailableScreen };
